/**
 * Created by iwona on 29.08.17.
 */
export default {

    faIconStyle: {
        marginRight: '5px'
    },

    buttonStyle: {
        fontWeight: "bold"
    },

    buttonCancelStyle: {
        fontWeight: "bold",
        marginRight: "5px",
        background: "#ddd"
    },

    buttonPointRemoveStyle: {
        borderColor: '#ccc',
        background: '#fff',
        color: '#c00',
        margin: '1px',
        width: '36px'

    },

    buttonPointEditStyle: {
        borderColor: '#ccc',
        background: '#fff',
        color: '#999',
        margin: '1px',
        width: '36px'

    },

    buttonPointInfoStyle: {
        borderColor: '#ccc',
        background: '#fff',
        color: '#33b5e5',
        margin: '1px',
        width: '36px'
    },

    buttonPointActionStyle: {
        margin: '1px',
        width: '36px'
    },

    buttonCommentEditStyle: {
        color: '#999'
    },

    buttonCommentRemoveStyle: {
        color: '#ff4444'
    },

    buttonCommentReplyStyle: {
        color: '#337ab7'
    },

    QuickActionBtnStyle:{
    },

    QuickActionBtnTextStyle:{
        margin: 'auto 8px'
    }

};



// WEBPACK FOOTER //
// ./src/componentsTopsa/buttons/TopButtonsStyles.js